import { ReactNode } from 'react';

interface SuccessMessageProps {
  children: ReactNode;
  additionalInfo?: ReactNode;
}

/**
 * SuccessMessage Component - Componente reutilizável para exibir mensagens de sucesso
 *
 * @example
 * ```tsx
 * <SuccessMessage>Login realizado com sucesso!</SuccessMessage>
 * ```
 *
 * @example
 * ```tsx
 * <SuccessMessage additionalInfo={<p>Redirecionando em 3 segundos...</p>}>
 *   Email verificado com sucesso!
 * </SuccessMessage>
 * ```
 */
export const SuccessMessage = ({ children, additionalInfo }: SuccessMessageProps) => {
  if (!children) return null;

  return (
    <div
      className="bg-[rgba(76,175,80,0.12)] border border-[#4CAF50] rounded-lg p-4"
      role="status"
      aria-live="polite"
    >
      <div className={`text-[#4CAF50] text-sm ${additionalInfo ? 'mb-2' : ''}`}>{children}</div>
      {additionalInfo && (
        <div className="text-[#4CAF50] text-sm">{additionalInfo}</div>
      )}
    </div>
  );
};
